<template>
  <div>
    <v-checkbox :label="mainLabel" v-model="groupSelected"></v-checkbox>
    <v-select
      v-model="selectedNames"
      :items="group.sort(customOrder)"
      multiple
      :item-text="formatLabel"
      item-value="settingName"
      label="Options"
      @change="onChange()"
      :outlined="outlinedInputs"
    >
      <template slot="selection" slot-scope="data"></template>
    </v-select>
    <div v-if="debug">
      <pre><code>{{JSON.stringify(updated,null,4)}}</code></pre>
      {{selectedNames}}
    </div>
  </div>
</template>

<script>
import { camelize } from "../../../helpers/index";

const settingsOrder = {'agents':['agent_and_groups', 'create_agent', 'edit_agent', 'delete_agent', 'edit_user', 'view_only', 'export']} //https://tracker.globetrack.ie/issues/7698


export default {
  name: "AccessSettingsGroup",

  props: {
    group: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      debug: false,
      selectedNames: this.group
        .filter(item => item.settingValue)
        .map(item => item.settingName)
    };
  },

  methods: {
    customOrder(a,b) { //https://tracker.globetrack.ie/issues/7698
      const group = a.groupName;
      if (settingsOrder[group]) {
        return settingsOrder[group].indexOf(a.settingName) - settingsOrder[group].indexOf(b.settingName)
      }
      return a.settingName.toString().localeCompare(b.settingName);
    },
    formatLabel(item) {
      let label = camelize(item.settingName).replace("Rates Importer", "Data Importer");
      if (this.$store.getters.isCPS) {
        label = label.replace("Brands", "Itinerary Destinations").replace("Lead Source", "Operations Team");
      }
      return label;
    },
    onChange() {
      this.$emit("change", this.updated);
    }
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    groupSelected: {
      get() {
        return this.selectedNames.length > 0;
      },
      set(value) {
        this.selectedNames = value
          ? this.group.map(item => item.settingName)
          : [];
        this.onChange();
      }
    },
    updated() {
      return this.group.map(s => ({
        groupName: s.groupName,
        settingName: s.settingName,
        settingValue: this.selectedNames.indexOf(s.settingName) != -1
      }));
    },
    mainLabel() {
      return camelize(this.group[0].groupName);
    }
  },
  mounted() {
    this.$emit("change", this.updated);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/gt/agents/AccessSettingsGroup.vue